














































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import { namespace } from 'vuex-class';
import { MetaInfo } from 'vue-meta';
import { Breadcrumbs as BreadcrumbsLayout } from '@/components/layout';
import { Paginator as PaginatorDefault } from '@/components/parts/pagination';
import SelectCount from '@/components/parts/catalog/list/count';
import { ListPageLayout } from '@/uikit';
import SiteMap from '@/components/layout/SiteMap.vue';
import { ListLayout, PaginationLayout } from '@/components/parts/listlayout';
import { ProfessionListCard } from '@/components/parts/professions';
import { Sort as CatalogSort } from '@/components/parts/catalog/list';
import { Yellow as FilterYellow } from '@/components/parts/filter';
import pageLimitChange from '@/pages/mixin-list';
import { filterMixin } from './mixins';
import mixinNav from '@/pages/mixin-nav';
import createStoreModule from './store';
import { Context } from './types';
import breadcrumbsMixin from '../mixins/breadcrumbs-mixin';
import {
  FILTER_MENU,
  DEFAULT_SORT,
  PAGE_SIZE,
  PAGE_NUMBER,
  STORE_MODULE_NAME,
  FETCH_ITEMS,
  LIMITS,
} from './consts';
import isArrayNotEmpty from '@/tools/isarraynotempty';

const Professions = namespace(STORE_MODULE_NAME);
const actions = mapActions(STORE_MODULE_NAME, [FETCH_ITEMS]);
const fetch = actions[FETCH_ITEMS];

@Component({
  components: {
    SiteMap,
    ListLayout,
    CatalogSort,
    SelectCount,
    FilterYellow,
    ListPageLayout,
    PaginationLayout,
    PaginatorDefault,
    BreadcrumbsLayout,
    ProfessionListCard,
  },

  storeName: STORE_MODULE_NAME,
  storeRegister: createStoreModule,

  inheritAttrs: false,

  metaInfo(): MetaInfo {
    return {
      title: 'Каталог профессий',
    };
  },
})
export default class ProfessionsList extends Mixins(
  breadcrumbsMixin,
  pageLimitChange,
  mixinNav,
  filterMixin,
) {
  @Prop({ type: String, default: DEFAULT_SORT })
  readonly sort: string;

  @Prop({ type: [String, Number], default: PAGE_NUMBER })
  readonly page: string | number;

  @Prop({ type: String, default: PAGE_SIZE })
  readonly limit: string;

  @Professions.State count: number;
  @Professions.State items: Array<any>;

  public sortNav = FILTER_MENU;

  get isContainData() {
    return isArrayNotEmpty(this.items);
  }

  get pageLimits() {
    return LIMITS.map((item) => {
      return {
        text: item,
        value: item,
      };
    });
  }

  get pageLimit() {
    return parseInt(this.limit);
  }

  get pagesCount() {
    return Math.ceil(this.count / this.pageLimit);
  }

  get sortList() {
    return this.sortNav.map(({ text, value }) => {
      const to = {
        ...this.$route,
        query: {
          ...this.$route.query,
          sort: value,
        },
      };
      return { text, to, active: this.sort === value };
    });
  }

  get filterProps() {
    const { localFilterFields, localFilterValues } = this;
    const key = JSON.stringify(localFilterValues);
    return {
      key,
      route: 'professions',
      fields: localFilterFields,
      values: localFilterValues,
      hasSwitcher: false,
      title: 'Поиск профессий',
    };
  }

  get localFilterValues() {
    const { filterValues, limit, sort } = this;
    const addedValues = {
      sort,
      limit,
    };
    return {
      ...filterValues,
      ...addedValues,
    };
  }

  get localFilterFields() {
    const addedFields = [
      { type: 'hidden', code: 'sort' },
      { type: 'hidden', code: 'limit' },
    ];

    return [...(this as any).filterFields, ...addedFields];
  }

  asyncData({ store, route }: Context): Promise<any> {
    const context = { $store: store };
    const params = {
      page: PAGE_NUMBER,
      limit: PAGE_SIZE,
      ...route.query,
      ...route.params,
    };
    return fetch.call(context, params);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/professions/list/ProfessionsList.vue